import { render, staticRenderFns } from "./AdminDetalleReposicion.vue?vue&type=template&id=36fc2e16&"
import script from "./AdminDetalleReposicion.vue?vue&type=script&lang=js&"
export * from "./AdminDetalleReposicion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AdminDetalleReposicion.vue"
export default component.exports